<template>
    <el-dialog id="ipCompanySearchDialog" title="公司代码查询" :visible.sync="dialogVisible" :width="width" @close="closeDialog" :close-on-click-modal="false" :append-to-body="appendToBody">
        <div v-if="!!showError.isShow" class="mb15">
            <el-alert :title="showError.message" type="warning" show-icon @close="showError.isShow = false"></el-alert>
        </div>
        <el-form label-width="110px" size="mini" @submit.native.prevent>
         	<el-row>
                <el-col :span="18">
                    <el-form-item label="搜索申请人：">
                        <el-input v-model="seachValue" @keyup.enter.native="search">
                            <el-button icon="el-icon-search" @click="search" slot="append"></el-button>
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <el-row class="corp-code-container" :gutter="15" v-loading="loading">
            <el-col :span="8">
                <div class="corp-code">
                    <h3>{{title.first}}</h3>
                    <div class="corp-code-tree">
                        <ip-tree :dataSet="treeDataCn" @nodeClick="handleNodeClick" @checkboxChangeEvent="handleCheckboxChangeEvent" @expandEvent="handleExpandEvent"></ip-tree>
                    </div>
                </div>
            </el-col>
             <el-col :span="8">
                  <div class="corp-code">
                    <h3>{{title.second}}</h3>
                    <div class="corp-code-tree">
                        <ip-tree :dataSet="treeDataEn" @nodeClick="handleNodeClick" @checkboxChangeEvent="handleCheckboxChangeEvent" @expandEvent="handleExpandEvent"></ip-tree>
                    </div>
                </div>
            </el-col>
             <el-col :span="8">
                 <div class="corp-code">
                    <h3>{{title.check}}</h3>
                    <ul class="corp-code-tree">
                        <li v-for="(item,index) in checkList">
                            <i class="del-btn el-icon-close" @click="deleteCheck(item,index)"></i>
                            <span :title="item">{{item}}</span>
                        </li>
                    </ul>
                </div>
            </el-col>
        </el-row>
         <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="clearCorpCodeModal">清空</el-button>
            <el-button  size="small" type="primary" @click="submitCompany">确定</el-button>
        </div>
    </el-dialog>
</template>
<script>
export default {
    name:'ipCompanyCodeSearchModel',
    props:{
        visible: {
            type: Boolean,
            default: false
        },
        width:{
            type: String,
            default: ''
        },
        title:{
            type:Object,
            default(){
                return {
                    first:'公司代码中文',
                    second:'公司代码英文',
                    check:'已选择申请人'
                }
            }
        },
        treeDataCn:{
            type:Array,
            default(){
                return []
            }
        },
        treeDataEn:{
            type:Array,
            default(){
                return []
            }
        },
        checkList:{
            type:Array,
            default(){
                return []
            }
        },
        loading:{
            type:Boolean,
            default:false
        },
        showError:{
            type:Object,
            default(){
                return {}
            }
        },
        appendToBody:{
            type:Boolean,
            default:true
        }
    },
    data(){
        return{
            seachValue:''
        }
    },
    computed:{
        dialogVisible:{
             // getter
            get(){
                return this.visible
            },
             // setter
            set(){
            }
        }
    },
    methods:{
        handleExpandEvent(node){
            this.$emit('expand',node,this.seachValue);
        },
        closeDialog(){
            this.$emit('closeDialog');
        },
        search(){
            this.$emit('search',this.seachValue);
        },
        submitCompany(){
            this.$emit('submit');
        },
        clearCorpCodeModal(){
            // this.seachValue = '';
            this.$emit('allClear');
        },
        handleNodeClick(node){
            this.$emit('nodeClick',node);
        },
        deleteCheck(item,index){
            this.$emit('deleteCheck',{item:item,index:index});
        },
        handleCheckboxChangeEvent(node){
            this.$emit('checkboxChange',node);
        }
    }
}
</script>
<style lang="scss">
#ipCompanySearchDialog {
    .el-dialog__body{
        padding: 15px 20px;
    }
    .el-dialog__header {
        background: $theme-color;
        height: 40px;
        line-height: 40px;
        padding: 0px 15px;
        box-sizing: border-box;
        .el-dialog__title{
            font-size: 16px;
            color: #ffffff;
        }
        .el-dialog__headerbtn{
            top: 12px;
        .el-dialog__close{
            color: #ffffff;
        }
        }
    }
}
</style>
<style lang="scss" scoped>
.mb15{
        margin-bottom:15px;
}
.corp-code-container {
    margin: 10px 0 0 0;
    .corp-code{
            border: 1px solid #cccccc;
        h3{
            font-size: 12px;
            color: #333333;
            padding: 8px;
            margin: 0;
            font-weight: normal;
            background: #f5f5f5;
        }
        ul{
            margin:0;
            padding:0;
        }
        .corp-code-tree{
            height: 291px;
            overflow: auto;
            li{
                padding:3px 0;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                -o-text-overflow: ellipsis;
                position: relative;
            }
            .del-btn{
                color: $theme-color;
                padding:0 5px;
                cursor: pointer;
            }
        }
    }
}
</style>

